import { API_BASE } from "@/lib/api";
import { Download, FileText, FileSpreadsheet } from "lucide-react";
import { Button } from "@/components/ui/button";

const REPORTS = [
    { key: "parcels", label: "Parcels", desc: "All parcels (root + sub) with shape, carat, clarity, color, cost." },
    { key: "jewelry", label: "Jewelry", desc: "All jewelry pieces with type, gold specs and allocated cost." },
    { key: "expenses", label: "Expenses", desc: "All value-add costs by target (parcel/jewelry) and paying partner." },
    { key: "sales", label: "Sales", desc: "Revenue with waterfall breakdown per partner." },
    { key: "ledger", label: "Partner ledger", desc: "Current capital, expense, profit and net-owed positions." },
];

export default function Reports() {
    const download = (kind, ext) => {
        const token = localStorage.getItem("session_token") || "";
        const url = `${API_BASE}/reports/${ext === "pdf" ? "pdf/ledger" : `csv/${kind}`}?auth=${encodeURIComponent(token)}`;
        window.open(url, "_blank");
    };

    return (
        <div className="space-y-6 animate-fade-up" data-testid="reports-page">
            <header>
                <div className="text-[10px] uppercase tracking-widest text-stone-500 mb-2">Exports</div>
                <h1 className="font-display text-4xl sm:text-5xl leading-none tracking-tight">Reports</h1>
                <p className="text-sm text-stone-500 mt-2 max-w-xl">Download CSVs for accounting, or a PDF snapshot of the partner ledger.</p>
            </header>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {REPORTS.map(r => (
                    <div key={r.key} className="border border-stone-200 bg-white p-5 flex items-start justify-between gap-4" data-testid={`report-card-${r.key}`}>
                        <div>
                            <div className="text-[10px] uppercase tracking-widest text-stone-500">CSV</div>
                            <div className="font-display text-2xl text-stone-900 mt-0.5">{r.label}</div>
                            <p className="text-sm text-stone-500 mt-1 max-w-sm">{r.desc}</p>
                        </div>
                        <Button onClick={() => download(r.key, "csv")} className="rounded-none bg-stone-900 text-stone-50 hover:bg-stone-800 shrink-0" data-testid={`download-csv-${r.key}`}>
                            <FileSpreadsheet className="h-4 w-4 mr-2" /> CSV
                        </Button>
                    </div>
                ))}
                <div className="border border-emerald-500/50 bg-emerald-50 p-5 flex items-start justify-between gap-4" data-testid="report-card-ledger-pdf">
                    <div>
                        <div className="text-[10px] uppercase tracking-widest text-emerald-700">PDF</div>
                        <div className="font-display text-2xl text-stone-900 mt-0.5">Ledger snapshot</div>
                        <p className="text-sm text-stone-500 mt-1 max-w-sm">Printable one-page summary of both partners&apos; positions.</p>
                    </div>
                    <Button onClick={() => download("ledger", "pdf")} className="rounded-none bg-emerald-600 hover:bg-emerald-500 text-white shrink-0" data-testid="download-pdf-ledger">
                        <FileText className="h-4 w-4 mr-2" /> PDF
                    </Button>
                </div>
            </div>
        </div>
    );
}
